import React from 'react';
import { Box } from '@mui/material';
import { DataGridPremium as MuiDatagrid } from '@mui/x-data-grid-premium';

import {
  ColumnUnsortedIcon,
  ColumnSortedAscendingIcon,
  ColumnSortedDescendingIcon,
  ColumnSeparatorIcon,
} from '@components';
import { GRID_PAGE_SIZE_OPTIONS } from '@constants';
import {
  useDataGridModel,
  useStableRowCount,
  useViewportGridHeight,
} from '@hooks';
import styles from './instaDataGrid.style';

const InstaDataGrid = ({
  apiRef,
  url,
  page,
  total,
  pageSize,
  rows = [],
  defaultPageSize,
  sx = {},
  customOffset = undefined,
  ...props
}) => {
  if (apiRef && !apiRef.current) {
    apiRef.current = {};
  }

  const { handlePaginationModelChange, handleSortModelChange } =
    useDataGridModel({
      url,
      page,
      pageSize,
      defaultPageSize,
    });

  const rowCount = useStableRowCount(total);
  const { gridHeight } = useViewportGridHeight({
    customOffset: customOffset || undefined,
  });

  const safeRows = Array.isArray(rows) ? rows : [];

  return (
    <Box sx={{ height: gridHeight }}>
      <Box sx={styles.container}>
        <MuiDatagrid
          apiRef={apiRef}
          sx={{
            ...styles.grid,
            ...styles.isNewGrid,
            ...styles.pagination,
            ...sx,
          }}
          disableColumnMenu
          showColumnVerticalBorder
          showCellVerticalBorder
          disableRowSelectionOnClick
          disableColumnSelector
          pagination
          localeText={{ noRowsLabel: 'No results found.' }}
          sortingMode="server"
          paginationMode="server"
          rowCount={rowCount}
          columnHeaderHeight={38}
          rowHeight={32}
          onSortModelChange={handleSortModelChange}
          onPaginationModelChange={handlePaginationModelChange}
          pageSizeOptions={GRID_PAGE_SIZE_OPTIONS}
          rows={safeRows}
          paginationModel={{
            page: page - 1,
            pageSize: pageSize || defaultPageSize,
          }}
          {...props}
          slots={{
            ...props.slots,
            columnSortedDescendingIcon: ColumnSortedDescendingIcon,
            columnSortedAscendingIcon: ColumnSortedAscendingIcon,
            columnUnsortedIcon: ColumnUnsortedIcon,
            columnResizeIcon: ColumnSeparatorIcon,
          }}
        />
      </Box>
    </Box>
  );
};

const memoizedInstaDataGrid = React.memo(InstaDataGrid);
export { memoizedInstaDataGrid as InstaDataGrid };

export default memoizedInstaDataGrid;
